(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('stayService', stayService);

    stayService.$inject = [
        '$http',
        '$q',
        'endPoints',
        'authorization'
    ];

    function stayService(
        $http,
        $q,
        endPoints,
        authorization
    ) {
        var service = {
            getStay: getStay,
            addStay: addStay,
			getList: getList,
			removeEstancias: removeEstancias,
        };

        return service;

        function getList(skip, take, sorting, filters, baja, frequencyFields, searchText, fromDate, toDate) {
            var deferred = $q.defer();
            var dateParams = '&fromDate=' + ((fromDate) ? fromDate.format('YYYY-MM-DD') : '') + '&toDate=' + ((toDate) ? toDate.format('YYYY-MM-DD') : '');
            var request = {
                method: 'POST',
                url: endPoints.entities.stays + 'getAll' + '?skip=' + skip + '&take=' + take + dateParams,
				data: {
					'sorting': sorting, 'filters': filters, 'dadosDeBaja': baja, 
					'frequencyFields': frequencyFields, 'searchTextByFrequencyFields': searchText
				}
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getStay(stayId) {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.entities.stays + 'get' + '?stayId=' + stayId
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function addStay(stay) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.entities.stays + 'add',
                data: stay
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                deferred.resolve(response.data);
            },
            function (response) {
                deferred.reject(null);
            });
            return deferred.promise;
		}

		function removeEstancias(estanciasIds) {
			var deferred = $q.defer();
			var request = {
				method: 'POST',
				url: endPoints.entities.stays + 'delete',
				data: estanciasIds
			};
			authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				deferred.resolve(response);
			},
				function (response) {
					deferred.reject(null);
				});
			return deferred.promise;
		}
        
    }
})();